// test1949
(1949 && 0);
